module.exports = __webpack_public_path__ + "media/format_video_2.2858903b.mp4";